/**
 *    @author: Andrew Sheen
 *    @since:  2020-10-30
 */

import { Component, OnInit,ElementRef,Input,AfterViewInit,Output, EventEmitter} from '@angular/core';
import { TimerService } from 'src/refresh/service/timer-service';
import { ControlBaseComponent } from "../control-base.component";

@Component({
  selector: 'ng-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.less']
})
export class CheckboxComponent extends ControlBaseComponent implements OnInit,AfterViewInit {

      private checkbox:any;

      private static id_no:number = 1;

      public  name:string;  // it is id in html

      constructor(private elRef:ElementRef,protected timerService:TimerService) { 
            super(timerService,1);
      }
      
      @Input('true')  trueValue:  any = "Y";
      @Input('false') falseValue: any = "N";
      
    //@Output('change')  : works
      
      public get className():string {
             return this.class_name;
      }

      public get inputClass():string {
             return "ontario-checkboxes__input " + this.input_class;
      }

      public get labelClass():string {
             return "ontario-checkboxes__label " + this.label_class;
      }


      public ngOnInit(): void {

             this.styleName = "padding-left:0.22em;"
             if ( this.id ) {
                  this.name = "chkbox_"+this.id;
             }
             else {
                  this.id = "chkbox_"+CheckboxComponent.id_no++;
                  this.name = this.id + "_ID";
             } 

             if ( this.input_class.indexOf("light-box") >= 0 ) {
                  if ( this.label_class ) this.label_class += " light-box";     
                  else                    this.label_class  = "light-box";     
             }
 

             if ( typeof this.input == 'boolean' ) {
                  this.trueValue  = true;
                  this.falseValue = false;
             }
             else
             if ( typeof this.input == 'number' ) {
                  this.trueValue  = 1;
                  this.falseValue = 0;
             }

             super.errorParamSet();
      }

      private labelDiv:any;
      public ngAfterViewInit() {

            this.checkbox = this.elRef.nativeElement.querySelector('input');

            this.labelDiv = this.elRef.nativeElement.querySelector('label');

            if ( this._disable ) {
                 this.labelDiv.style.opacity = 0.5;
            }
            else this.labelDiv.style.opacity = 1;

            super.layoutFromViewInit(this.checkbox.parentElement.parentElement);
      }

      @Input('ng-disable') set  disable(value:boolean) {

            this._disable = value;
               
            /**
            if ( value )  {
                 if ( this.label_class ) this.label_class += " disable-grey";
                      this.label_class = " disable-grey";
            }
            else {
                 let idx = this.label_class.indexOf("disable-grey");
                 if ( idx >= 0 ) {
                      this.label_class = this.label_class.substring(0,idx).trim();
                 }
            }
             */

            if ( this.labelDiv ) {
                  if ( value ) {
                        this.labelDiv.style.opacity = 0.5;
                  }
                  else this.labelDiv.style.opacity = 1;
            }
     }

      get disable():boolean {
              return this._disable;
      }

      public onChange() {

            if ( this.checkbox.checked ) {
                 if (this.input == this.trueValue ) return;
            } 
            else {
                  if (this.input == this.falseValue ) return;
            }

            if ( this.checkbox.checked ) {
                 this.input = this.trueValue;              
            }
            else this.input = this.falseValue;

            super.valueChanged();
       }
}
